import { Dispatch } from 'redux';

import * as ErrorConstant from 'constants/error';

import { FlashMessageActionCreators } from 'actions/flashMessage';
import { ErrorResponse } from 'models/error';

export function handleGenericApiError(defaultMessage: string, errorResponse: ErrorResponse, dispatch: Dispatch<void>) {
  const dangerModifier = 'danger';
  if (!errorResponse.body || !errorResponse.body.error) {
    dispatch(FlashMessageActionCreators.show.create({
      modifier: dangerModifier,
      text: defaultMessage
    }));
    return;
  }

  const { error } = errorResponse.body;
  switch (error) {
    case ErrorConstant.EMAIL_ALREADY_EXIST: {
      dispatch(FlashMessageActionCreators.show.create({
        modifier: dangerModifier,
        text: 'error.email.already.exist'
      }));
      break;
    }
    case ErrorConstant.ACCOUNT_IS_NOT_REGISTERED: {
      dispatch(FlashMessageActionCreators.show.create({
        modifier: dangerModifier,
        text: 'error.account.is.not.registered'
      }));
      break;
    }
    case ErrorConstant.ENTITY_NOT_FOUND: {
      dispatch(FlashMessageActionCreators.show.create({
        modifier: dangerModifier,
        text: 'error.entity.not.found'
      }));
      break;
    }
    case ErrorConstant.SEND_EMAIL_FAILED: {
      dispatch(FlashMessageActionCreators.show.create({
        modifier: dangerModifier,
        text: 'error.send.email.failed'
      }));
      break;
    }
    case ErrorConstant.INVALID_REQUEST: {
      dispatch(FlashMessageActionCreators.show.create({
        modifier: dangerModifier,
        text: 'error.invalid.request'
      }));
      break;
    }
    case ErrorConstant.OTP_EXPIRED: {
      dispatch(FlashMessageActionCreators.show.create({
        modifier: dangerModifier,
        text: 'error.otp.expired'
      }));
      break;
    }
    case ErrorConstant.OTP_MAX_RESEND_REACHED: {
      dispatch(FlashMessageActionCreators.show.create({
        modifier: dangerModifier,
        text: 'error.otp.max.resend.reached'
      }));
      break;
    }
    case ErrorConstant.OTP_MAX_WRONG_REACHED: {
      dispatch(FlashMessageActionCreators.show.create({
        modifier: dangerModifier,
        text: 'error.otp.max.wrong.reached'
      }));
      break;
    }
    case ErrorConstant.OTP_MISMATCH: {
      dispatch(FlashMessageActionCreators.show.create({
        modifier: dangerModifier,
        text: 'error.otp.mismatch'
      }));
      break;
    }
    case ErrorConstant.OTP_SENT_FAILED: {
      dispatch(FlashMessageActionCreators.show.create({
        modifier: dangerModifier,
        text: 'error.otp.sent.failed'
      }));
      break;
    }
    case ErrorConstant.PASSWORD_MISMATCH: {
      dispatch(FlashMessageActionCreators.show.create({
        modifier: dangerModifier,
        text: 'error.password.mismatch'
      }));
      break;
    }
    case ErrorConstant.PHONE_ALREADY_SET: {
      dispatch(FlashMessageActionCreators.show.create({
        modifier: dangerModifier,
        text: 'error.phone.already.set'
      }));
      break;
    }
    case ErrorConstant.PHONE_ALREADY_EXIST: {
      dispatch(FlashMessageActionCreators.show.create({
        modifier: dangerModifier,
        text: 'error.phone.already.exist'
      }));
      break;
    }
    case ErrorConstant.SIZE_LIMIT_EXCEEDED: {
      dispatch(FlashMessageActionCreators.show.create({
        modifier: dangerModifier,
        text: 'error.size.limit.exceeded'
      }));
      break;
    }
    default: {
      dispatch(FlashMessageActionCreators.show.create({
        modifier: dangerModifier,
        text: defaultMessage
      }));
    }
  }
}

export function handleInvoiceApiError(defaultMessage: string, errorResponse: ErrorResponse, dispatch: Dispatch<void>) {
  const dangerModifier = 'danger';
  if (!errorResponse.body || !errorResponse.body.error) {
    dispatch(FlashMessageActionCreators.show.create({
      modifier: dangerModifier,
      text: defaultMessage
    }));
    return;
  }

  const { error } = errorResponse.body;
  switch (error) {
    case ErrorConstant.ENTITY_NOT_FOUND: {
      dispatch(FlashMessageActionCreators.show.create({
        modifier: dangerModifier,
        text: 'error.invoice.entity.not.found'
      }));
      break;
    }
    case ErrorConstant.INVALID_REQUEST: {
      dispatch(FlashMessageActionCreators.show.create({
        modifier: dangerModifier,
        text: 'error.invalid.request'
      }));
      break;
    }
    case ErrorConstant.INVOICE_OPERATION_ERROR: {
      dispatch(FlashMessageActionCreators.show.create({
        modifier: dangerModifier,
        text: 'error.invoice.operation.error'
      }));
      break;
    }
    default: {
      dispatch(FlashMessageActionCreators.show.create({
        modifier: dangerModifier,
        text: defaultMessage
      }));
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helper/error.ts